import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { Props } from "./interfaces";
import {
  PopoverContainer,
  AnomaliesListContainer,
  AnomalyRow,
  AnomalyTypeName,
  AnomalyDaysCount,
  PopoverContent,
  PopoverAnomalyRow,
} from "./styles";
import { LightTooltip } from "../../../../reusable-components/CustomTooltip/CustomTooltip";
import SimplePopover from "../../../../reusable-components/SimplePopover/SimplePopover";

const AnomaliesPopover = ({ anomalies }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  if (!anomalies || anomalies.length === 0) {
    return null;
  }

  const hasMoreAnomalies = anomalies.slice(3).length > 0;

  return (
    <PopoverContainer>
      <AnomaliesListContainer
        container
        direction={"column"}
        hasMoreAnomalies={hasMoreAnomalies}
      >
        {anomalies.slice(0, 3).map((anomaly) => (
          <AnomalyRow key={uuidv4()}>
            <LightTooltip title={anomaly.anomalyType?.name}>
              <AnomalyTypeName>&#8226; {anomaly.anomalyType?.name}</AnomalyTypeName>
            </LightTooltip>
            <LightTooltip
              title={t(`common_words.days.${anomaly.anomalyCount === 1 ? "days" : "days_plural"}`, {
                count: anomaly.anomalyCount,
              })}
            >
              <AnomalyDaysCount>
                {t(`common_words.days.${anomaly.anomalyCount === 1 ? "days" : "days_plural"}`, {
                  count: anomaly.anomalyCount,
                })}
              </AnomalyDaysCount>
            </LightTooltip>
          </AnomalyRow>
        ))}
      </AnomaliesListContainer>

      {/* Show three dots if there are more anomalies */}
      {hasMoreAnomalies && (
        <SimplePopover
          buttonType="icon"
          buttonContent={
            <FontAwesomeIcon
              icon={faEllipsisH}
              style={{ fontSize: "12px", color: theme.palette.text.secondary, cursor: "pointer" }}
            />
          }
        >
          <PopoverContent>
            {anomalies.slice(2).map((anomaly) => (
              <PopoverAnomalyRow key={uuidv4()}>
                <LightTooltip title={anomaly.anomalyType?.name}>
                  <AnomalyTypeName>{anomaly.anomalyType?.name}</AnomalyTypeName>
                </LightTooltip>
                <LightTooltip
                  title={t(`common_words.days.${anomaly.anomalyCount === 1 ? "days" : "days_plural"}`, {
                    count: anomaly.anomalyCount,
                  })}
                >
                  <AnomalyDaysCount>
                    {t(`common_words.days.${anomaly.anomalyCount === 1 ? "days" : "days_plural"}`, {
                      count: anomaly.anomalyCount,
                    })}
                  </AnomalyDaysCount>
                </LightTooltip>
              </PopoverAnomalyRow>
            ))}
          </PopoverContent>
        </SimplePopover>
      )}
    </PopoverContainer>
  );
};

export default AnomaliesPopover;
